import styled from 'styled-components';

export const ModalStyle = styled.div`
  position: relative;
  max-width: 96%;
  height: fit-content;
  min-height: 28rem;
  max-height: 96%;
  outline: none;
  border-radius: 12px;
  background: #fff;
`;

export const OverlayStyle = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500;
  background: rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(5px);
  opacity: 0;
  transition: all 300ms ease-in-out;

  &[class*='--after-open'] {
    opacity: 1;
  }

  &[class*='--before-close'] {
    opacity: 0;
  }
`;
